import * as types from "../constants/actionsTypes";

const initialState = {
    list: [],
    inProfitList: [],
    waitCallClientsList: [],
    loading: false,
    inProfitLoading: false,
    error: null,
    paginator: {
        page: 1,
        size: 70,
        total: 0
    },
    profitListType: "",
    clientsListType: "",
    salesOrders: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case types.CLIENTS_UPDATE_CALLS_DATE_REQUEST:
        case types.CLIENT_CHANGE_REQUEST:
        case types.CLIENT_REMOVE_REQUEST:
        case types.CARD_IN_WORK_REQUEST:
        case types.CARD_CANCEL_IN_WORK_REQUEST:
        case types.CLIENTS_EXPORTED_REQUEST:
        case types.LOAD_SALES_ORDERS_OF_SUPPLIER_REQUEST:
        case types.CREATE_SALES_ORDER_REQUEST:
        case types.CANCEL_SALES_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case types.CLIENT_ADD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                redirect_url: ""
            };

        case types.CLIENTS_LOAD_REQUEST:
        case types.CLIENTS_FULL_LIST_LOAD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                list: []
            };

        case types.CLIENTS_IN_PROFIT_LOAD_REQUEST:
            return {
                ...state,
                inProfitLoading: true,
                error: null,
                inProfitList: []
            };

        case types.CLIENTS_IN_PROFIT_LOAD_FAILURE:
            return {
                ...state,
                inProfitLoading: false,
                error: action.error
            };

        case types.CLIENTS_IN_PROFIT_LOAD_SUCCESS:
          return {
            ...state,
            inProfitLoading: false,
            inProfitList: action.list.items,
            profitListType: action.list.type
          };

        case types.WAIT_FOR_CALL_CLIENTS_LOAD_REQUEST:
            return {
                ...state,
                inWaitForCallClientsLoading: true,
                waitCallClientsList: []
            };

        case types.WAIT_FOR_CALL_CLIENTS_LOAD_SUCCESS:
            return {
                ...state,
                inWaitForCallClientsLoading: false,
                waitCallClientsList: action.list.items
            };

        case types.CLIENTS_UPDATE_CALLS_DATE_SUCCESS:
        case types.CLIENTS_LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.clients,
                paginator: action.data.pager
            };

        case types.CLIENTS_UPDATE_CALLS_DATE_FAILURE:
        case types.CLIENTS_LOAD_FAILURE:
        case types.CLIENT_CHANGE_FAILURE:
        case types.CLIENT_REMOVE_FAILURE:
        case types.CLIENT_ADD_FAILURE:
        case types.CARD_IN_WORK_FAILURE:
        case types.CARD_CANCEL_IN_WORK_FAILURE:
        case types.LOAD_SALES_ORDERS_OF_SUPPLIER_FAILURE:
        case types.CREATE_SALES_ORDER_FAILURE:
        case types.CANCEL_SALES_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case types.CLIENT_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                redirect_url: action.client.redirect_url,
                error: null
            };

        case types.CLIENT_CHANGE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.client,
                error: null
            };

        case types.CLIENTS_FULL_LIST_LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.items,
                clientsListType: action.data.type
            };

        case types.CLIENT_REMOVE_SUCCESS:
            return {
                ...state,
                loading: false,
                list: []
            };

        case types.CALC_MAP_PRICE_REQUEST:
          return {
            ...state,
            priceUpdating: true
          };

        case types.CALC_MAP_PRICE_FAILURE:
            return {
                ...state,
                priceUpdating: false
            };

        case types.CLIENTS_EXPORTED_SUCCESS:

            return {
                ...state,
                downloadingExportCardsUrl: action.data.report_url,
                loading: false
            };
        case types.LOAD_SALES_ORDERS_OF_SUPPLIER_SUCCESS:

            return {
                ...state,
                loading: false,
                salesOrders: action.salesOrders
            };
        case types.CREATE_SALES_ORDER_SUCCESS:
        case types.CANCEL_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/clients.js